import { Pipe, PipeTransform } from '@angular/core';
import { humanize } from 'src/util/text';

@Pipe({
  name: 'humanize',
})
export class HumanizePipe implements PipeTransform {
  public transform(value: any, args?: any): any {
    return humanize(value);
  }
}
